/**
 * スムーススクロール（Vanilla JS） ver1.0.0
 * 一部 Jquery使用
 * ES6
 *
 * □機能
 * スムーススクロール系
 *
 * □使い方
 * アンカーやページトップ
 */
export default (APP) => {
  // スクロールターゲット
  const scrollble = APP.el.scrolling

  // ページトップターゲット
  const $pagetop = document.getElementById('pagetop')

  // アンカーターゲット
  const targets = document.querySelectorAll('a[href^="#"]:not([data-anchor="false"])')
  const targetsLength = targets.length

  // ヘッダー
  // const $header = document.getElementById('header-bar')
  // const headerHeight = $header.offsetHeight

  /*
   * OffsetTopの計算
   */
  function calcOffsetTop ($element) {
    let result = 0
    const rect = $element.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    result = rect.top + scrollTop

    return result
  }

  /*
   * 実際の処理：アンカー
   */
  function process (event) {
    event.preventDefault()

    const $this = event.currentTarget
    const option = {}

    option.speed = 400
    option.href = $this.getAttribute('href')
    option.$target = document.querySelector(option.href)
    option.position = calcOffsetTop(option.$target)

    if (APP.ua.isMobile || APP.ua.isTablet) {
      option.position -= 60
    }

    // jQuery animate を使用
    $(scrollble).stop().animate(
      {
        scrollTop: option.position
      },
      option.speed,
      'easeInOutQuad'
    )
  }

  // ターゲットがある場合イベント追加
  if (targets) {
    for (let i = 0; i < targetsLength; i++) {
      const $target = targets[i]

      $target.addEventListener('click', process, false)
    }
  }

  /*
   * 実際の処理：ページトップ
   */
  if ($pagetop) {
    $pagetop.addEventListener('click', function (event) {
      event.preventDefault()

      // jQuery animate を使用
      $(scrollble).stop().animate(
        {
          scrollTop: 0
        },
        350,
        'easeInOutQuad'
      )
    }, false)
  }
}
